{
  document.addEventListener("DOMContentLoaded", function () {
    const videoBoxes = document.querySelectorAll(".why-choose-video-box");
    let currentlyPlaying = null;
    videoBoxes.forEach((box) => {
      const video = box.querySelector("video");
      const playBtn = box.querySelector(".video-playBtn");
      playBtn.addEventListener("click", function () {
        if (currentlyPlaying === video) {
          video.pause();
          box.classList.remove("active");
          playBtn.classList.remove("active");
          currentlyPlaying = null;
          return;
        }
        if (currentlyPlaying) {
          currentlyPlaying.pause();
          currentlyPlaying
            .closest(".why-choose-video-box")
            .classList.remove("active");
          currentlyPlaying
            .closest(".why-choose-video-box")
            .querySelector(".video-playBtn")
            .classList.remove("active");
        }
        video.play();
        box.classList.add("active");
        playBtn.classList.add("active");
        currentlyPlaying = video;
      });
      video.addEventListener("pause", function () {
        if (currentlyPlaying === video) {
          box.classList.remove("active");
          playBtn.classList.remove("active");
          currentlyPlaying = null;
        }
      });
      video.addEventListener("ended", function () {
        box.classList.remove("active");
        playBtn.classList.remove("active");
        currentlyPlaying = null;
      });
    });
  });
}

{
  document.addEventListener("DOMContentLoaded", function () {
    function faqsAccordion() {
        var accordionSections = document.querySelectorAll(".accordion-item");

        // if (accordionSections.length > 0) {
        //     var firstAccordionItemHeader = accordionSections[0].querySelector(
        //         ".accordion-item-header"
        //     );
        //     var firstAccordionItemBody = firstAccordionItemHeader.nextElementSibling;

        //     if (firstAccordionItemBody) {
        //         firstAccordionItemHeader.classList.add("active");
        //         firstAccordionItemBody.style.maxHeight =
        //             firstAccordionItemBody.scrollHeight + "px";
        //     }

        //     for (let i = 1; i < accordionSections.length; i++) {
        //         var otherHeader = accordionSections[i].querySelector(".accordion-item-header");
        //         var otherBody = otherHeader.nextElementSibling;

        //         if (otherBody) {
        //             otherHeader.classList.remove("active");
        //             otherBody.style.maxHeight = "0";
        //         }
        //     }
        // }

        accordionSections.forEach((section) => {
            var accordionItemHeaders = section.querySelector(".accordion-item-header");
            var accordionItemBody = section.querySelector(".accordion-item-body");

            accordionItemHeaders.addEventListener("click", function () {
                var currentlyActiveHeader = document.querySelector(
                    ".accordion-item-header.active"
                );
                var currentlyActiveBody = currentlyActiveHeader
                    ? currentlyActiveHeader.nextElementSibling
                    : null;

                if (currentlyActiveHeader && currentlyActiveBody) {
                    currentlyActiveHeader.classList.remove("active");
                    currentlyActiveBody.style.maxHeight = 0;
                }

                if (accordionItemHeaders !== currentlyActiveHeader) {
                    accordionItemHeaders.classList.add("active");
                    accordionItemBody.style.maxHeight =
                        accordionItemBody.scrollHeight + "px";
                } else {
                    accordionItemHeaders.classList.remove("active");
                    accordionItemBody.style.maxHeight = 0;
                }
            });
        });
    }

    faqsAccordion();
});
}

